import React from 'react'
import { Container, Row, Col, Accordion } from 'react-bootstrap';
import { motion } from "motion/react";
import servicesData from "../../data/servicesData.json";

const FAQ = () => {
    const accordionVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: (index) => ({
            opacity: 1,
            y: 0,
            transition: { duration: 0.5, delay: index * 0.1 }
        })
    }

    return (
        <section className="section-lg bg-light overflow-hidden" id="growth-services">
            <Container>
                <Row>
                    <Col xs={12} className='mb-5'>
                        <motion.h6 initial={{ opacity: 0, y: -30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 1, ease: 'linear', delay: 0.1 }} className="underline-after position-relative text-center z-0">
                            <span className="position-relative z-1 bg-white text-primary px-3">FAQ</span>
                        </motion.h6>
                        <motion.h1 initial={{ opacity: 0, scale: 0 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 1, ease: 'linear', delay: 0.1 }} className="d-block text-gradiant text-center fw-semibold">Answers to common questions</motion.h1>
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    <Col lg={8} xs={12}>
                        <Accordion defaultActiveKey="0">
                            {servicesData.faqs.map((faq, index) => (
                                <motion.div className={index !== servicesData.faqs.length - 1 ? 'mb-4' : ''}
                                    key={faq.id}
                                    variants={accordionVariants}
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true }}
                                    custom={index}
                                >
                                    <Accordion.Item eventKey={String(index)}>
                                        <Accordion.Header>{faq.question}</Accordion.Header>
                                        <Accordion.Body>
                                            {faq.answer}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </motion.div>
                            ))}
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default FAQ;